import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectShowCLOListing } from 'redux/app/selectors';
import { selectUser } from 'redux/user/selector';
import CLOModalListing from './CLOModalListing';

type Props = {
  enquiryDetail: any;
  handleCLOViewDetailsClick: Function;
  searchText: string;
  setSearchText: Function;
  addressState: string[];
  setAddressState: Function;
  order: string;
  setOrder: Function;
  screenSize: any;
  withHidden: boolean;
  setWithHidden: Function;
  currentPage: number;
  setCurrentPage: Function;
  pageOffset: number;
  setPageOffset: Function;
};

const CLOModalSection: React.FC<Props> = (props: Props) => {
  const {
    enquiryDetail,
    handleCLOViewDetailsClick,
    searchText,
    setSearchText,
    addressState,
    setAddressState,
    order,
    setOrder,
    screenSize,
    withHidden,
    setWithHidden,
    currentPage,
    setCurrentPage,
    pageOffset,
    setPageOffset
  } = props;
  const showCLOListing = useSelector(selectShowCLOListing);
  const user = useSelector(selectUser);
  const [showCLO, setShowCLO] = useState<boolean>(false);

  useEffect(() => {
    if (showCLOListing && user) {
      let showFlag = showCLOListing?.[user?.id];
      if (showCLOListing?.[user?.id] === undefined) {
        showFlag = true;
      }
      setShowCLO(showFlag);
    } else if (showCLOListing === undefined) {
      setShowCLO(true);
    }
  }, [user, showCLOListing]);

  const CLImgName = 'certloc';
  console.log('enquiryDetail in CLOModalSection', enquiryDetail);
  return (
    <>
      <div className="visible-height"></div>
      <div className="clo-section">
        <div className="engage-certified-locator">
          <div className="static-content">
            <div className="content">
              <img
                src={`../${CLImgName}.png`}
                srcSet={`../${CLImgName}.png, ../${CLImgName}@2x.png 2x, ../${CLImgName}@3x.png 3x`}
                alt="certloc certifications"
                className="certified-locator-icon"
              />
            </div>
            <div className="text">
              Underground infrastructure networks are complex and require expert
              knowledge to identify the location of buried services carefully
              and safely. To reduce the risk of accidental damage or workplace
              injury, we highly recommend the services of a Certified Locator.
              The Certified Locator program is owned and operated by
              <a
                href="https://certloc.com.au/locators"
                target="_blank"
                rel="noopener noreferrer"
              >
                CERTLOC Global
              </a>
              .
            </div>
          </div>
          <div className="why-use-certified-locator">
            <div className="title">Why use a Certified Locator?</div>
            <div className="paragraph">
              It&apos;s highly recommended to engage a Certified Locating
              Organisation/Certified Locator to help prevent accidental damage.
              The use of Certified Locators is required by some major utilities,
              such as Telstra.
            </div>
            <div className="paragraph">
              Certified Locators are nationally recognised for meeting the
              minimum industry standard for locating excellence, best practice
              and safety. They are skilled in interpreting utility plans,
              diligently investigating a site, and navigating complex utility
              networks, to locate and identify the underground utilities present
              at your worksite.
            </div>
          </div>
          {showCLO ? (
            <div className="certified-locators-listing">
              <div>
                <div className="header">
                  <div className="title">
                    Certified Locating Organisations servicing this job site
                  </div>
                </div>
                <div className="text">
                  <span>About this list.</span>
                  When you lodge an enquiry, Certified Locating Organisations
                  (CLOs) servicing your dig site area are shown here. These CLOs
                  are sorted by distance and filtered by the state of your job
                  site.
                </div>
              </div>
              <CLOModalListing
                enquiryDetail={enquiryDetail}
                handleCLOViewDetailsClick={handleCLOViewDetailsClick}
                searchText={searchText}
                setSearchText={setSearchText}
                addressState={addressState}
                setAddressState={setAddressState}
                order={order}
                setOrder={setOrder}
                screenSize={screenSize}
                withHidden={withHidden}
                setWithHidden={setWithHidden}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageOffset={pageOffset}
                setPageOffset={setPageOffset}
              />
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  );
};

export default CLOModalSection;
